import {
  // location map
  UPDATE_PLACE_CLICKED,
  UPDATE_SHOW_ALL_PLACES,
  UPDATE_SELECTED_PLACE,
  // UPDATE_SHOW_ALL_PLACES,
  RESET_SELECTED_PLACES,
  SHOW_ONLY_USER_SELECTED_LOCATIONS,
  SHOW_ALL_NEARBY_PLACES,
} from './types';

export const updateShowAllPlaces = showAllPlaces => {
  return {
    type: UPDATE_SHOW_ALL_PLACES,
    payload: {
      showAllPlaces,
    },
  };
};

export const updateSelectedPlace = place => {
  return {
    type: UPDATE_PLACE_CLICKED,
    payload: {
      place,
    },
  };
};

export const showOnlyUserSelectedLocations = () => {
  return {
    type: SHOW_ONLY_USER_SELECTED_LOCATIONS,
  };
};


export const updateSelectedPlaces = places => {
  return {
    type: UPDATE_SELECTED_PLACE,
    payload: {
      places,
    },
  };
};

export const showAllNearbyPlaces = nearbyPlaces => {
  return {
    type: SHOW_ALL_NEARBY_PLACES,
    payload: {
      selectedPlaces: nearbyPlaces,
    },
  };
};

export const resetSelectedPlaces = () => {
  return {
    type: RESET_SELECTED_PLACES,
  };
};
